// extracted by mini-css-extract-plugin
export default {"not__found":"NotFound_not__found__JkTLm","image":"NotFound_image__q660q"};